import styled from "styled-components";

export const Container = styled.div`
  margin-top: 24px;
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadow.default};
  width: 100%;
`;

export const TitleContainer = styled.div`
  height: 32px;
  position: relative;
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.colors.gray[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: none;
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -24px;
  height: 56px;
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.orange.primary};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.2);

  h2 {
    font-weight: 600;
    font-size: 18px;
    text-align: center;
  }
`;

export const CustomTableContainer = styled.div`
  border-radius: 0 0 16px 16px;
  width: 100%;

  .MuiAccordionSummary-content {
    margin: 0;
  }

  .MuiAccordionSummary-gutters, .MuiAccordionDetails-root {
    padding: 0 !important;
  }

  .Mui-expanded {
    margin: 0 !important;
    min-height: 48px !important;

    &.MuiAccordionSummary-gutters {
      border-bottom: 1px solid #E5E4E5;
    }
    &.MuiPaper-elevation {
      border-top: 1px solid #E5E4E5;
    }
  }

  div:first-child {
    ::-webkit-scrollbar:horizontal {
      display: block;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #D9D9D9;
    }

    ::-webkit-scrollbar-thumb {
      background: #F58220; 
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #d57523; 
    }
  }
  
  table {
    overflow-x: auto;

    border-collapse: collapse;
    width: 100%;
    border-radius: 0 0 8px 8px;
    color: ${({ theme }) => theme.colors.gray[600]};

    td, th {
      text-overflow: ellipsis;
      text-align: center; /* Centraliza o conteúdo das células */
      max-height: 58px;
      max-width: 80px;
      min-width: 80px;
      
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  th {
    padding: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    background-color: ${({ theme }) => theme.colors.white};

    height: 52px;
  }
  th:last-child {
    padding-right: 10px;
  }

  td {
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    font-family: 'Poppins';
    line-height: 24px;

    button {
      border: none;
      background: transparent;
      color: #f58220;
      font-weight: 500;
      text-decoration: underline;
      transition: filter 0.2s;
      &:hover {
        filter: brightness(0.8);
      }
    }

    span {
      font-weight: 700;
      font-size: 10px;
      line-height: 24px;
      color: #ffffff;
      padding: 0 18px;
      border-radius: 4px;

      &.warning {
        background-color: var(--warning-color);
      }

      &.info {
        background-color: var(--info-color);
      }

      &.danger {
        background-color: var(--danger-color);
      }

      &.success {
        background-color: var(--success-color);
      }
    }
  }

  tr {
    height: 48px;
  }

  tr:nth-child(1) {
    border-top: none;
  }

  // tr:nth-child(odd) {
  //   background-color: ${({ theme }) => theme.colors.gray.debtsTable};
  // }

  // tr:nth-child(even) {
  //   background-color: ${({ theme }) => theme.colors.white};
  // }
`;

export const ExpansiveRowContainer = styled.div<{isEven?: boolean, isFooterRow?: boolean}>`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  height: 48px;
  background-color: ${({ isFooterRow, isEven, theme }) =>  isFooterRow ? "#FDE4CE" : isEven ? theme.colors.gray.debtsTable : theme.colors.white};
  ${({isFooterRow}) => isFooterRow ? "border-radius: 0 0 16px 16px;" : ""}
    
  .expansive-row-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;

    span {
      font-weight: 600;
      line-height: 20px;
      color: ${({ isFooterRow }) =>  isFooterRow ? "#F58220" : "#424242"};  
    }
  }
`;

export const ExpandedTableContainer = styled.div`
  max-height: 385px;
  overflow-x: auto;

  tr {
    border: 1px solid #E5E4E5;
  }
`;